import styles from './AccountAdmin.module.scss';
import Card, { CardHeader } from '../../../components/Card';
import classNames from 'classnames/bind';
import {
  AccountAdminData,
  NON_US_STATE,
} from '../../../state/enrollment/enrollmentModel';
import {
  setAccountAdminOne,
  setAccountAdminTwo,
} from '../../../state/enrollment/enrollmentActions';
import AccountAdminForm from './AccountAdminForm';
import Summary from '../Summary';

const cx = classNames.bind(styles);

const cardHeaderClasses = {
  wrapper: cx('account-admin__card-title-wrapper'),
  title: cx('account-admin__card-title'),
};

export enum AccountAdminStep {
  ONE = 'ONE',
  TWO = 'TWO',
}

export interface AccountAdminProps {
  accountAdminOne: AccountAdminData;
  accountAdminTwo: AccountAdminData;
  step: AccountAdminStep;
  setAccountAdminOne: typeof setAccountAdminOne;
  setAccountAdminTwo: typeof setAccountAdminTwo;
}

const AccountAdmin = (props: AccountAdminProps) => {
  const {
    accountAdminOne,
    accountAdminTwo,
    step,
    setAccountAdminOne,
    setAccountAdminTwo,
  } = props;

  const isAdminOneStep: boolean = step === AccountAdminStep.ONE;

  const onAccountAdminSubmit = (
    formValues: AccountAdminData,
    saveAccountAdmin: (data: AccountAdminData) => void
  ) => {
    formValues.nonUSAddress = formValues.state === NON_US_STATE;
    saveAccountAdmin(formValues);
  };

  const onSubmitAdminOne = (formValues: AccountAdminData) => {
    onAccountAdminSubmit(formValues, setAccountAdminOne);
  };
  const onSubmitAdminTwo = (formValues: AccountAdminData) => {
    onAccountAdminSubmit(formValues, setAccountAdminTwo);
  };

  const subtitle = isAdminOneStep
    ? 'Account Administrator 1 will be the EDGAR point of contact on your account.  This is required for EDGAR Next enrollment.'
    : undefined;

  return (
    <div className={cx('account-admin')}>
      <Card className={cx('account-admin__card')}>
        <CardHeader
          title="Enrollment and Administration"
          subtitle={subtitle}
          smallLogo
          classes={cardHeaderClasses}
        />
        {isAdminOneStep ? (
          <AccountAdminForm
            title="1ST ACCOUNT ADMINISTRATOR"
            initialValues={accountAdminOne}
            onSubmit={onSubmitAdminOne}
          />
        ) : (
          <AccountAdminForm
            title="2ND ACCOUNT ADMINISTRATOR"
            initialValues={accountAdminTwo}
            onSubmit={onSubmitAdminTwo}
          />
        )}
      </Card>
      <Summary />
    </div>
  );
};

export default AccountAdmin;
